import { Component, Inject, Input, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Apollo } from 'apollo-angular';
import { MenuItem } from 'primeng/api';
import { DynamicDialogRef } from 'primeng/dynamicdialog/public_api';
import { TableLazyLoadEvent } from 'primeng/table';
import { Group } from '../../entities/group/group';
import { LoadingService } from '../../services/loading.service';
import { ToastService } from '../../services/toast/toast.service';
import { EditDialogService } from '../editDialog/editDialogService';
import { GroupDialogComponent } from '../group-dialog/group-dialog.component';
import { GroupDataSource } from './groupDataSource';


@Component({
  selector: 'app-group-list',
  templateUrl: './group-list.component.html',
  styleUrls: ['./group-list.component.scss']
})
export class GroupListComponent implements OnDestroy
{

  dialogRef: DynamicDialogRef | undefined;
  
  public groups: Group [];
  private sortProperty = 'name';
  private sortDirection = 'asc';
  public pageNumber = 0;
  public pageSize = 15;
  public loading = false;
  public dataSource: GroupDataSource;

  @Input() withMainHeadline = true;
  public pageTitleMenuItems: MenuItem[]

  constructor(
    private loadingService: LoadingService,
    private apollo: Apollo,
    private router: Router,
    @Inject('env') private environment : any,
    private toastService: ToastService,
    public dialogService: EditDialogService
  ) {
    this.setTableDataSource();
  }

  setTableDataSource(): void{
    this.dataSource = new GroupDataSource(this.apollo, this.environment);
    this.dataSource.loading.subscribe((loading) => {
      this.loading = loading;
    });
    this.dataSource.loadUsers({
      number: this.pageNumber,
      size: this.pageSize,
      sortProperty: this.sortProperty,
      sortDirection: this.sortDirection,
    });
  }

  ngOnDestroy(): void {
    this.dataSource.disconnect();
  }

  createGroup(): void {
    this.dialogRef = this.dialogService.open(GroupDialogComponent, {
      header: 'Gruppe erstellen'
    });
    this.dialogRef.onClose.subscribe((result) => {
      // result is true or false, indiciating if it should refetch
      if(result){
        this.refetchGroups();
        this.loadingService.setLoading(false);
        this.toastService.addToastWithAction('Gruppe erfolgreich erstellt.', 'Anzeigen', () => {
          this.router.navigate(['./settings/groups/group/' + result]);
        });
      }
    });
  }

  refetchGroups(): void {
    this.dataSource.refetchQuery({
      number: this.pageNumber,
      size: this.pageSize,
      sortProperty: this.sortProperty,
      sortDirection: this.sortDirection,
    }, true);
  }


  loadData(event: TableLazyLoadEvent) {
    this.loading = true;

    // sorting
    if (event?.sortField !== undefined && typeof event?.sortField == 'string') {
      this.sortProperty = event.sortField;
    }
    if (event?.sortOrder !== undefined) {
      this.sortDirection = event.sortOrder === 1 ? 'asc' : 'desc';
    }

    // pagination
    this.pageNumber = event?.first !== undefined ? event.first / event.rows : 0;
    this.pageSize = event?.rows !== undefined ? event.rows : 15;

    this.refetchGroups();
  }

  openGroup(group: Group): void {
    this.router.navigate(['./settings/groups/group/' + group.id]);
  }

}

